<template>
  <div v-show="displayFrontend" :class="{questions__save: safeFreeze}" class="questions">

    <h1 class="questions__header">{{ $t("Hourtypes") }}</h1>
    <p>{{
        $t("In Dyflexis we have default hour types and allowances available. You register these hours and numbers in the hours overview. For the components listed below, specify whether you want to see these hour types reflected in your system.")
      }}</p>

    <p v-show="showPayrollConnection"><b>{{ $t("Please note") }}</b>, {{
        $t("take into account the payment connection. Which hour types does the salary package require that you may not have thought of yourself? Discuss this in advance with your accountant.")
      }}</p>

    <b-form-checkbox
      v-model="hourTypes.workedHours"
      class="checkbox d-inline-block width14vw inputHeight" disabled name="check-button" switch>
      {{ $t("Hours worked") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.workedHours"
      v-model="payrollConnectionCodes.workedHours[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.workedHours"
      v-model="payrollConnectionCodes.workedHours[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.holidayLeave"
      class="checkbox d-inline-block width14vw inputHeight" disabled name="check-button" switch>
      {{ $t("Holiday Hours") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.holidayLeave"
      v-model="payrollConnectionCodes.holidayLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.holidayLeave"
      v-model="payrollConnectionCodes.holidayLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-show="shortTimeWorkingHours>0"
      v-model="hourTypes.workTimeReduction" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Worktime reduction hours") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.workTimeReduction"
      v-model="payrollConnectionCodes.workTimeReduction[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.workTimeReduction"
      v-model="payrollConnectionCodes.workTimeReduction[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.sicknessAbsence" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Sickness leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.sicknessAbsence"
      v-model="payrollConnectionCodes.sicknessAbsence[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.sicknessAbsence"
      v-model="payrollConnectionCodes.sicknessAbsence[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.waitdayAbsence" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Sickness waiting day") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.waitdayAbsence"
      v-model="payrollConnectionCodes.waitdayAbsence[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.waitdayAbsence"
      v-model="payrollConnectionCodes.waitdayAbsence[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.payedLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button" switch>
      {{ $t("Paid leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.payedLeave"
      v-model="payrollConnectionCodes.payedLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.payedLeave"
      v-model="payrollConnectionCodes.payedLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.unpaidLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button" switch>
      {{ $t("Unpaid leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.unpaidLeave"
      v-model="payrollConnectionCodes.unpaidLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.unpaidLeave"
      v-model="payrollConnectionCodes.unpaidLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.specialLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button" switch>
      {{ $t("Special leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.specialLeave"
      v-model="payrollConnectionCodes.specialLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.specialLeave"
      v-model="payrollConnectionCodes.specialLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.maternityLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Pregnancy leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.maternityLeave"
      v-model="payrollConnectionCodes.maternityLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.maternityLeave"
      v-model="payrollConnectionCodes.maternityLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.feastdayLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Public holiday leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.feastdayLeave"
      v-model="payrollConnectionCodes.feastdayLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.feastdayLeave"
      v-model="payrollConnectionCodes.feastdayLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.birthLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button" switch>
      {{ $t("Birth leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.birthLeave"
      v-model="payrollConnectionCodes.birthLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.birthLeave"
      v-model="payrollConnectionCodes.birthLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.birthAdditionalLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Additional birth leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.birthAdditionalLeave"
      v-model="payrollConnectionCodes.birthAdditionalLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.birthAdditionalLeave"
      v-model="payrollConnectionCodes.birthAdditionalLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.careLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button" switch>
      {{ $t("Care leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.careLeave"
      v-model="payrollConnectionCodes.careLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.careLeave"
      v-model="payrollConnectionCodes.careLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.emergencyLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Emergency leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.emergencyLeave"
      v-model="payrollConnectionCodes.emergencyLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.emergencyLeave"
      v-model="payrollConnectionCodes.emergencyLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.shortTermLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Short-term leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.shortTermLeave"
      v-model="payrollConnectionCodes.shortTermLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.shortTermLeave"
      v-model="payrollConnectionCodes.shortTermLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.doctorLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button" switch>
      {{ $t("Doctor's leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.doctorLeave"
      v-model="payrollConnectionCodes.doctorLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.doctorLeave"
      v-model="payrollConnectionCodes.doctorLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.parentalLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Parental leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.parentalLeave"
      v-model="payrollConnectionCodes.parentalLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.parentalLeave"
      v-model="payrollConnectionCodes.parentalLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.unpaidParentalLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Unpaid parental leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.unpaidParentalLeave"
      v-model="payrollConnectionCodes.unpaidParentalLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.unpaidParentalLeave"
      v-model="payrollConnectionCodes.unpaidParentalLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <b-form-checkbox
      v-model="hourTypes.educationalLeave" class="checkbox d-inline-block width14vw inputHeight" name="check-button"
      switch>
      {{ $t("Educational leave") }}
    </b-form-checkbox>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.educationalLeave"
      v-model="payrollConnectionCodes.educationalLeave[0]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Fixed')}`"
      class="max10vw d-inline-block questions__halfInputWidthLeft"
      type="text">
    </b-form-input>
    <b-form-input
      v-if="showPayrollConnection&&hourTypes.educationalLeave"
      v-model="payrollConnectionCodes.educationalLeave[1]"
      :disabled="readOnly"
      :placeholder="`${$t('Wage code')} ${$t('Variable')}`"
      class="max10vw d-inline-block"
      type="text">
    </b-form-input>
    <br>

    <p class="question--extraMarginTop">
      {{ $t("Do you have any other hourly types that cannot be processed in the section above?") }}</p>
    <b-form-checkbox
      v-model="showAdditionalHours" name="check-button" switch @change="hourTypes.additionalHours=null">
      {{ $t("Yes, we have additional hourly types") }}
    </b-form-checkbox>
    <div v-show="showAdditionalHours">
      <p class="question--marginTop">
        {{ $t("Please describe the hourly types below, these will be discussed during the intake.") }}</p>

      <b-form-textarea
        id="textarea-auto-height"
        v-model="hourTypes.additionalHours"
        class="questions__textarea footerMargin"
        max-rows="10"
        rows="3"/>
      <p><b>{{ $t("Please note") }},</b>
        {{ $t("if these hourly type(s) differ from the standard configuration, this is an additional component.") }}</p>
    </div>

    <p class="question--extraMarginTop">{{ $t("Do you use standby, sleep or consignment shifts?") }}</p>
    <b-form-checkbox
      v-model="showConsignmentShift" name="check-button" switch @change="hourTypes.consignmentShift=null">
      {{ $t("Yes, we use standby, sleep or consignment shifts") }}
    </b-form-checkbox>
    <div v-show="showConsignmentShift">
      <p class="question--marginTop">{{
          $t("In Dyflexis standby shifts with a fixed fee are standard in the package, we can also facilitate standby services with exceptions, however there may be additional costs. Please describe your standby service below, the consultant will discuss this with you during the intake.")
        }}</p>

      <b-form-textarea
        id="textarea-auto-height"
        v-model="hourTypes.consignmentShift"
        class="questions__textarea footerMargin"
        rows="3"
      />
    </div>

    <h1 class="question--marginTop questions__header">{{ $t("Reimbursements") }}</h1>
    <p>{{ $t("Allowances can always be applied to worked hours by an administrator. Employees can only add reimbursements themselves if hours can also be registered by the employees via the app.") }}</p>
    <p>{{$t("Which reimbursements do you have?")}}</p>
    <b-form-checkbox
      v-model="hourTypes.mealCompensation" class="checkbox" name="check-button" switch>
      {{ $t("Meal") }}
    </b-form-checkbox>
    <b-form-checkbox
      v-model="hourTypes.distanceCompensation" class="checkbox" name="check-button" switch>
      {{ $t("Distance") }}
    </b-form-checkbox>
    <b-form-checkbox
      v-model="hourTypes.workFromHomeCompensation" class="checkbox" name="check-button" switch>
      {{ $t("Working from home") }}
    </b-form-checkbox>
    <b-form-checkbox
      v-model="hourTypes.otherCompensationsEnabled" class="checkbox" name="check-button" switch>
      {{ $t("Other reimbursements") }}
    </b-form-checkbox>
    <br>
    <b-form-textarea
      id="textarea-auto-height"
      v-show="hourTypes.otherCompensationsEnabled"
      v-model="hourTypes.otherCompensations"
      class="questions__textarea"
      rows="3"
    />

    <h1 class="question--marginTop questions__header">{{ $t("Automatic distance calculation") }}</h1>
    <p>{{$t("It is possible to automatically calculate the distance between the home address of the employee, and the office where the employee is scheduled. Would you like to make use of this?")}}</p>
    <b-form-checkbox
      v-model="hourTypes.automaticDistanceCalculation"
      class="checkbox"
      name="check-button"
      switch>
      {{ $t("Yes, we would like to use automatic distance calculation") }}
    </b-form-checkbox>

    <input :value="$t('Save')" type="button" @click="handleSave"/>
    <p v-show="showSaveStatus" class="questions--savesuccess">{{ $t("Saved successfully!") }}</p>
  </div>
</template>

<script>
import SystemRequestService from "@/SystemRequestService";
import GlobalFunctions from "@/GlobalFunctions";

export default {
  name: 'HourTypes',
  data() {
    return {
      displayFrontend: false,
      safeFreeze: false,
      showSaveStatus: false,
      readOnly: false,
      showPayrollConnection: false,
      showAdditionalHours: false,
      showConsignmentShift: false,
      shortTimeWorkingHours: false,
      hourTypes: {
        workedHours: true,
        holidayLeave: true,
        payedLeave: false,
        specialLeave: false,
        maternityLeave: false,
        workTimeReduction: false,
        feastdayLeave: false,
        birthLeave: false,
        birthAdditionalLeave: false,
        careLeave: false,
        emergencyLeave: false,
        shortTermLeave: false,
        doctorLeave: false,
        unpaidLeave: false,
        parentalLeave: false,
        unpaidParentalLeave: false,
        educationalLeave: false,
        sicknessAbsence: false,
        waitdayAbsence: false,
        additionalHours: null,
        consignmentShift: null,
        mealCompensation: false,
        distanceCompensation: false,
        workFromHomeCompensation: false,
        otherCompensationsEnabled: false,
        otherCompensations: null,
        automaticDistanceCalculation: null,
        payrollConnectionCodes: null,
      },
      payrollConnectionCodes: {
        workedHours: [null, null],
        holidayLeave: [null, null],
        payedLeave: [null, null],
        specialLeave: [null, null],
        maternityLeave: [null, null],
        workTimeReduction: [null, null],
        feastdayLeave: [null, null],
        birthLeave: [null, null],
        birthAdditionalLeave: [null, null],
        careLeave: [null, null],
        emergencyLeave: [null, null],
        shortTermLeave: [null, null],
        doctorLeave: [null, null],
        unpaidLeave: [null, null],
        parentalLeave: [null, null],
        unpaidParentalLeave: [null, null],
        educationalLeave: [null, null],
        sicknessAbsence: [null, null],
        waitdayAbsence: [null, null],
      }
    };
  },
  async beforeMount() {
    const result = await SystemRequestService.getProject(this.$route.params.hashedId);
    if (!result) {
      alert(this.$t("Error while obtaining your details. Please try again later or contact your Dyflexis consultant."));
      return;
    }

    if (result.contracts !== null) {
      this.shortTimeWorkingHours = JSON.parse(result.contracts).amountShortTimeWorkingHours;
    }

    if (result.hourTypes !== null) {
      this.hourTypes = JSON.parse(result.hourTypes);
      try {
        this.payrollConnectionCodes = JSON.parse(this.hourTypes.payrollConnectionCodes);
        if (!("unpaidParentalLeave" in this.payrollConnectionCodes)) {
          this.payrollConnectionCodes.unpaidParentalLeave = [null,null];
        }

        if (!("educationalLeave" in this.payrollConnectionCodes)) {
          this.payrollConnectionCodes.educationalLeave = [null,null];
        }
      } catch (error) {
        console.log('Error on decoding payroll connections JSON');
      }
    }

    if (this.hourTypes.additionalHours) {
      this.showAdditionalHours = true;
    }

    if (this.hourTypes.consignmentShift) {
      this.showConsignmentShift = true;
    }

    GlobalFunctions.setReadOnly(result.isSigned);
    localStorage.setItem('startingObject', JSON.stringify(this.hourTypes));
    this.displayFrontend = true;
  },
  beforeRouteLeave: function (to, from, next) {
    if (!GlobalFunctions.acceptPageLeave(this.hourTypes, this.$t("You have made changes without saving them. Press cancel to ignore these changes and leave the page."))) {
      this.handleSave(false);
    }
    next();
  },
  methods: {
    async handleSave(saveInitialObject) {
      this.safeFreeze = true;

      this.hourTypes.payrollConnectionCodes = JSON.stringify(this.payrollConnectionCodes);
      const result = await SystemRequestService.updateProject(this.hourTypes, this.$route.params.hashedId);
      if (!result || result.status !== 'success') {
        alert(this.$t("Error while updating, please send a screenshot of the fields on this page to your Dyflexis consultant!"));
        return;
      }

      if (saveInitialObject !== false) {
        localStorage.setItem('startingObject', JSON.stringify(this.hourTypes));
      }

      this.safeFreeze = false;
      this.showSaveStatus = true;
      setTimeout(() => {
        this.showSaveStatus = false;
        location.reload();
      }, 3000);
    },
    removeHtml(text) {
      if (text == null) {
        return text;
      }

      let tmp = document.createElement("DIV");
      tmp.innerHTML = text.replaceAll("</p><p>", "\n").replaceAll("<br>", "\n");
      return tmp.textContent || tmp.innerText || "";
    }
  },
};
</script>
